import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: ({startDate}, pagination, ordering, download = 0) => ({
        ...pagination,
        ordering,
        download,
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:                'CMDBDeviceDetails',
        endpoint:            endpoints.cmdb.deviceDetails,
        timeout:             TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformEntitiesFn: item => ({
            memoryGb:        item.memory_gb,
            operatingSystem: item.operating_system,
            className:       item.class_name,
            ciName:          item.ci_name,
            cpuCore:         item.cpu_core,
            model:           item.model,
            cpu:             item.cpu,
            manufacturer:    item.manufacturer,
            eol:             item.eol && item.eol.slice(0,10) //To take just the date and ignore the hour.
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/CMDBDeviceDetails.js